import {
  BdExportAsFileFormConfig,
  BdExportAsFileTriggerConfig,
} from '../export/export.config';

export const BD_EXPORT_AS_FILE_ASYNC_CONFIG_DEFAULT: BdExportAsFileAsyncConfig =
  {
    trigger: {
      tooltipText: 'Export',
      dataTestKey: 'export-trigger',
    },
    form: {
      defaultLabels: [],
      availableExportTypes: ['xlsx'],
    },
  };

export interface BdExportAsFileAsyncConfig {
  form: Omit<BdExportAsFileFormConfig, 'availableExportTypes'> & {
    /**
     * Export formats offered in the dialog's "Typ" picker. Defaults to `['xlsx']`
     * (via {@link BD_EXPORT_AS_FILE_ASYNC_CONFIG_DEFAULT}); the picker only renders
     * when more than one type is offered, so existing single-format exports are
     * unchanged. The chosen type is handed to
     * {@link BdExportAsFileAsyncData.trigger}'s `exportType` argument.
     */
    availableExportTypes?: ('csv' | 'xlsx')[];
  };
  trigger: BdExportAsFileTriggerConfig;
  exportTemplate?: {
    initialExportTemplateId?: string;
    initialExportProperties?: string[];
  };
}
